export function formatDateString(dateString: string | undefined): string {
	if (!dateString) return 'NÃO HÁ';

	let data;

	if (dateString.includes('/')) {
		const [dia, mes, ano] = dateString.split('/').map(Number);
		data = new Date(ano, mes - 1, dia);
	} else {
		data = new Date(dateString);
	}

	if (Number.isNaN(data.getTime())) return 'NÃO HÁ';

	const dia = String(data.getDate()).padStart(2, '0');
	const mes = String(data.getMonth() + 1).padStart(2, '0');
	const ano = data.getFullYear();

	return `ATÉ ${dia}/${mes}/${ano}`;
}
